import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import Form from "./app/form.js";
import Sticky from "sticky-js";
import ScrollReveal from "scrollreveal";
import buildFormat from './app/format.js';
import OwlCarousel from 'owl.carousel';
import NewsTab from './app/news-tab';
import Tentsu from './app/tentsu.js';
import Slider from './app/slider.js';

// バージョン固定のままdart-sassに対応させたいので複製をインポート
// import fontAwesome from "font-awesome/scss/font-awesome.scss"
import "./font-awesome/scss/font-awesome.scss"
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css"
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css"

class App {
  constructor() {
    const self = this;

    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();
    this.Form = new Form();
    this.NewsTab = new NewsTab();
    this.Tentsu = new Tentsu();
    this.Slider = new Slider();

    //SPメニューの高さ取得
    function menuHight() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }

      var $smpHeaderHeight = $('.l-header').height();
      var windowHeight = window.innerHeight;
      var winH = windowHeight - $smpHeaderHeight;

      //動かすターゲットを取得
      var targetSlidebarWrap = $('.c-slidebar-menu'),
        targetSlidebarMenu = $('.c-slidebar__parent'),
        targetSlidebarBtn = $('.c-slidebar-menu__parent');


      //いざ実行(クリックしたら処理を実行する)
      targetSlidebarBtn.on('click', function () {
        $('.c-slidebar-menu').toggleClass('is-active');

      });
    }

    //フッターメニューSPスライド
    function menuSlide() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }
      $('.l-footer__block').on('click', function () {
        $(this).children(".l-footer__menutitle").toggleClass('is-open');
        $(this).children(".l-footer__menulist.is-sub").slideToggle();
      })
    }

    //owlcarousel
    function owlCarousel() {
      var owls = $('.owl-carousel');
      if (owls.length === 0) {
        return false
      }
      //->スライダー
      owls.imagesLoaded(function () {
        $('.c-main-visual__slider').owlCarousel({
          items: 1,
          margin: 0,
          dots: true,
          loop: true,
          nav: false,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          animateOut: "fadeOut",
          navText: ['<img src="/wp-content/themes/tenpo-html/dist/assets/images/icon-slider-prev.svg" />', '<img src="/wp-content/themes/tenpo-html/dist/assets/images/icon-slider-next.svg" />'],
        });
      });
      //->カルーセル
      owls.imagesLoaded(function () {
        $('.c-main-visual__carousel').owlCarousel({
          items: 1,
          margin: 16,
          dots: true,
          loop: true,
          nav: true,
          autoplayHoverPause: true,
          autoplay: false,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          navText: ['<div class="c-main-visual__nav is-left"><i class="fa fa-angle-left" aria-hidden="true"></i></div>', '<div class="c-main-visual__nav is-right"><i class="fa fa-angle-right" aria-hidden="true"></i></div>'],
          responsive: {
            // breakpoint from 0 up
            0: {
              stagePadding: 32,
            },
            // breakpoint from 750  up
            750: {
              stagePadding: 64,
            },
            // breakpoint from 950 up
            950: {
              stagePadding: 156,
            },
            1400: {
              stagePadding: 312,
            }
          }
        });
      });
      //->カルーセル_ノーマル
      owls.imagesLoaded(function () {
        $('.c-main-visual__carousel.is-normal').owlCarousel({
          items: 1,
          margin: 8,
          dots: true,
          loop: true,
          nav: true,
          autoplayHoverPause: true,
          autoplay: false,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          navText: ['<div class="c-main-visual__nav is-left"><i class="fa fa-angle-left" aria-hidden="true"></i></div>', '<div class="c-main-visual__nav is-right"><i class="fa fa-angle-right" aria-hidden="true"></i></div>'],
          responsive: {
            // breakpoint from 0 up
            0: {
              stagePadding: 32,
            },
            // breakpoint from 750  up
            750: {
              stagePadding: 64,
            },
            // breakpoint from 950 up
            950: {
              stagePadding: 156,
            },
            1400: {
              stagePadding: 312,
            }
          }
        });
      });
      //->カルーセル_レイヤー
      owls.imagesLoaded(function () {
        $('.c-main-visual-layer__carousel').owlCarousel({
          items: 1,
          margin: 0,
          dots: true,
          loop: true,
          nav: false,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          navText: ['<img src="/wp-content/themes/tenpo-html/dist/assets/images/icon-slider-prev.svg" />', '<img src="/wp-content/themes/tenpo-html/dist/assets/images/icon-slider-next.svg" />'],
        });
      });
      //->カード_カルーセル
      owls.imagesLoaded(function () {
        $('.js-card-slider').owlCarousel({
          margin: 0,
          dots: false,
          loop: true,
          nav: true,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          navText: ['<img src="/wp-content/themes/tenpo-html/dist/assets/images/icon-slider-prev.svg" />', '<img src="/wp-content/themes/tenpo-html/dist/assets/images/icon-slider-next.svg" />'],
          responsive: {
            // breakpoint from 0 up
            0: {
              items: 1,
            },
            // breakpoint from 750 up
            750: {
              items: 3,
            }
          }
        });
      });
      // 協業業者募集フォーム 実例
      owls.imagesLoaded(function () {
        $('.js-precedent-slider').owlCarousel({
          margin: 0,
          dots: true,
          dotsEach: true,
          loop: true,
          nav: true,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          navText: ['<img src="/wp-content/themes/tenpo-html/dist/assets/images/icon-slider-prev.svg" />', '<img src="/wp-content/themes/tenpo-html/dist/assets/images/icon-slider-next.svg" />'],
          responsive: {
            // breakpoint from 0 up
            0: {
              items: 1,
              nav: false,
            },
            // breakpoint from 750 up
            750: {
              items: 2,
              nav: false,
            },
            950: {
              items: 3,
            }
          }
        });
      });
    }

    function form_radio() {
      var check = $('.radio_check input');
      check.on('change', function () {
        check.siblings('select').addClass('is-hidden');
        $(this).siblings('select').toggleClass('is-hidden');
      });

    }

    function latestLocation() {
      var param = location.search;

      if (param == "") {
        return false;
      }

      var tabs = $('.js-tabs-nav');
      tabs.children('li').children('a').removeClass('is-active');
      $('.c-tabs__content').removeClass('is-active');
      if (param == "?latest=info") {
        $('#info').addClass('is-active');
        $('#info-content').addClass('is-active');
      } else if (param == "?latest=press") {
        $('#press').addClass('is-active');
        $('#press-content').addClass('is-active');
      }
      else if (param == "?latest=shop") {
        $('#shop').addClass('is-active');
        $('#shop-content').addClass('is-active');
      }
    }

    /**
     * 店通スライダー初期化
     */
    async function initTentsuSlider() {
      // 記事を取得してからスライダーの初期化を行う
      await self.Tentsu.setLatestPosts();
      self.Slider.initTentsuSlider();
    }

    $(function () {
      window.sr = ScrollReveal({duration: 600, mobile: false});

      function domEach(items, callback) {
        if (typeof items === "string") {
          var items = $(items);
        }
        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          // callback = callback.bind(item)
          callback(i, item);
        }
      }

      // 汎用クラス
      sr.reveal(".js-reveal", {origin: 'bottom', distance: '50px', duration: 1000, viewFactor: .3}, 100);
      //トップページ
      sr.reveal(".c-about-renewal__images", {origin: 'bottom', distance: '50px', duration: 1000, viewFactor: .3}, 100);
      sr.reveal(".c-business__image", {origin: 'bottom', distance: '50px', duration: 1000, viewFactor: .3}, 100);
      var blocks01 = $(".c-recruit-renewal__block");
      domEach(blocks01, function (key, item) {
        sr.reveal(item, {scale: 1, duration: 1000, origin: 'bottom', delay: 0, distance: '100px', viewFactor: .4}, 200);
        sr.reveal(item.children[1], {
          duration: 1000,
          delay: 200,
          scale: 1,
          origin: 'bottom',
          distance: '100px',
          viewFactor: .4
        }, 300);
      });

      function myCallback(el) {
        el.classList.add('is-animating');
      }

      ScrollReveal().reveal('#example', {beforeReveal: myCallback});
    });


    $(function () {
      var win = $(window).innerWidth();
      if (win > 750) {
        if ($(".c-archive-aside").length > 0) {
          var sticky = new Sticky('.c-archive-aside');
        }
        // if ($(".l-aside").length > 0) {
        //   var sticky = new Sticky('.l-aside');
        // }
      }
      //form_radio();
      //latestLocation();
      //menuSlide();
      owlCarousel();
      initTentsuSlider();
    });
  }
}

window.GApp = new App();
